import IconGlowWrapper from '@/app/components/IconGlowWrapper'
import React, { useState, useRef, useEffect } from 'react'
import PanelFFXIV from '@/app/components/PanelFFXIV'
import PhotosphereQualitySelector from '@/app/components/PhotosphereQualitySelector'
import GameQualitySelector from '@/app/components/GameQualitySelector'
import AudioSettings from '@/app/components/AudioSettings'
import { AnimatePresence, motion } from 'framer-motion'
import { IoSettings, IoSettingsOutline } from 'react-icons/io5'
import { AUDIO, useAudio } from '@/app/providers/AudioProvider'

const ServerBarConfig = () => {
    const [isOpen, setIsOpen] = useState(false)
    const { play } = useAudio();
    const panelRef = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (panelRef.current && !panelRef.current.contains(event.target as Node) && buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isOpen])

    return (
        <>
            <div
            ref={buttonRef}
            onMouseEnter={() => { play(AUDIO.HOVER)}}
            onClick={() => { play(AUDIO.CLICK); setIsOpen(!isOpen); }}
            className="cursor-pointer pointer-events-auto"
            >
                <IconGlowWrapper icon={isOpen ? <IoSettings /> : <IoSettingsOutline />} className="text-[18px] xl:text-[22px]" color="yellow" />
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        ref={panelRef}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.1 }}
                        className="!fixed top-12 right-4 text-shadow-none text-white z-50 pointer-events-auto"
                    >
                        <PanelFFXIV className="border-2 border-x-[#c0a270] border-y-[#e0c290] w-fit">
                            <div className="flex flex-col gap-4">
                                <AudioSettings />
                                <GameQualitySelector />
                                <PhotosphereQualitySelector />
                            </div>
                        </PanelFFXIV>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    )
}

export default ServerBarConfig